import { j as s } from "./kezios-design-system.esm172.js";
import x from "react";
import { Container as n, Flex as p, Stack as i, Text as t } from "@mantine/core";
import e from "./kezios-design-system.esm187.js";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const u = ({
  title: c,
  descriptionFirstLine: l,
  descriptionSecondLine: o,
  cta: d,
  image: a,
  ...m
}) => /* @__PURE__ */ s.jsx(n, { style: { width: "100%" }, size: "100%", bg: "gray.0", ...m, children: /* @__PURE__ */ s.jsx(n, { size: 1600, px: r.s4, style: { width: "100%" }, children: /* @__PURE__ */ s.jsxs(p, { className: e.container, w: "100%", children: [
  /* @__PURE__ */ s.jsxs(
    i,
    {
      className: e.half,
      gap: r.s10,
      p: r.s16,
      justify: "center",
      children: [
        /* @__PURE__ */ s.jsxs(i, { gap: r.s5, justify: "center", children: [
          /* @__PURE__ */ s.jsx(t, { variant: "displayMd.semibold", c: "gray.9", children: c }),
          /* @__PURE__ */ s.jsxs(i, { gap: r.s2, children: [
            /* @__PURE__ */ s.jsx(t, { variant: "textXl", c: "gray.6", children: l }),
            /* @__PURE__ */ s.jsx(t, { variant: "textXl", c: "gray.6", children: o })
          ] })
        ] }),
        d
      ]
    }
  ),
  /* @__PURE__ */ s.jsx("div", { className: `${e.half} ${e.imageContainer} desktop`, children: a && x.cloneElement(a, { className: e.image }) })
] }) }) });
export {
  u as DownloadSection
};
